import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { clearChoicesGeolocations, getChoicesGeolocations } from '../../../../modules/actions/choices'
import { choicesGeolocationsLoadingSelector, choicesGeolocationsSelector } from '../../../../modules/selectors/choices'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { SHOW_REGIONS_CITY_TYPE, SHOW_REGIONS_REGION_TYPE } from '../../../Facebook/fields'

const FacebookGeolocationRegion = ({ selectedCountry, name, value, setFieldValue }) => {
  const dispatch = useDispatch()

  const geolocations = useSelector(choicesGeolocationsSelector)
  const geolocationsLoading = useSelector(choicesGeolocationsLoadingSelector)
  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  const formattedGeolocations = useMemo(
    () =>
      geolocations &&
      geolocations
        .filter(({ type }) => type === SHOW_REGIONS_REGION_TYPE || type === SHOW_REGIONS_CITY_TYPE)
        .map(item => {
          const { key, name, region, type, region_id } = item

          // include region name if it is exist in data
          const itemRegion = region ? `, ${region}` : ''

          return { value: key, label: name + itemRegion, type, region_id }
        }),
    [geolocations]
  )

  const getGeolocations = useCallback(
    searchValue => {
      searchValue &&
        dispatch(
          getChoicesGeolocations({
            account: selectedAdAccountId,
            country_code: selectedCountry && selectedCountry.iso2,
            search: searchValue
          })
        )
    },
    [dispatch, selectedCountry, selectedAdAccountId]
  )

  useEffect(
    () => () => {
      dispatch(clearChoicesGeolocations())
    },
    [dispatch]
  )

  return (
    <MultiSelectBox
      name={name}
      options={formattedGeolocations}
      value={value}
      isLoading={geolocationsLoading}
      setFieldValue={setFieldValue}
      onSearch={getGeolocations}
    />
  )
}

export default FacebookGeolocationRegion
